/**
 * tabData.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 탭 메뉴의 순서도 입니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */


/**
 * 탭 메뉴의 데이터입니다.
 * (초기 기준) 본래 이 탭 메뉴는 서버에서 수정도 된다고 했었는데 이번 사업에는 포함되지 않게 되어 사실상 디폴트 값으로 사용되고 있습니다.
 * 
 * ※ 만약 탭 순서를 변경하길 원한다면 아래 배열에서 순서를 수정해 주세요.
 * ※ 만약 이름을 변경하길 원한다면 nmName을 수정해 주세요.
 */
export const SectionData = [
  {
    mnName: '개요',
    src: '#/sales/',
    mnCode: 'A'
  },
  {
    mnName: '분양',
    src: '#/sales/info',
    mnCode: 'B'
  },
  {
    mnName: '사이버 주택전시관',
    src: '#/sales/exhbt',
    mnCode: 'C'
  },
  {
    mnName: '입지',
    src: '#/sales/location',
    mnCode: 'D'
  },
  {
    mnName: '단지',
    src: '#/sales/street',
    mnCode: 'E'
  },
  {
    mnName: '세대',
    src: '#/sales/household',
    mnCode: 'F'
  },
  // {
  //   mnName: '이벤트',
  //   src: '#/sales/event',
  //   mnCode: 'G'
  // },
  {
    mnName: '소식',
    src: '#/sales/news',
    mnCode: 'H'
  }
];
